// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Container, Box, Grid, Typography, IconButton, TextField, InputAdornment, Card, CardContent, Divider, Dialog, DialogContent, Button } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { HiOutlineXCircle, HiOutlineClock, HiOutlineCalendar } from "react-icons/hi";
// import { MdSearch } from "react-icons/md";
// import { FaLockOpen, FaLock } from "react-icons/fa";
// import { Person as PersonIcon, Phone as PhoneIcon, Email as EmailIcon, LocationCity as LocationCityIcon } from "@mui/icons-material";
// import FormattedDate from "../components/FormattedDate";
// import ComplainForm from "./ComplainForm"; // Import ComplainForm
// import CloseIcon from '@mui/icons-material/Close';
// import { useAuth } from '../context/AuthContext';

// const categories = ["Search", "Missed", "Today", "Open", "Close"];

// const sortRecordsForTeamLeader = (records, userId) => {
//     const recs = Array.isArray(records) ? records : [];
//     return recs.sort((a, b) => {
//         const aIsSelf = a.AddUserId === userId;
//         const bIsSelf = b.AddUserId === userId;
//         if (aIsSelf && !bIsSelf) return -1;
//         if (!aIsSelf && bIsSelf) return 1;
//         const dateA = new Date(a.AddUserDateTime || "1970-01-01");
//         const dateB = new Date(b.AddUserDateTime || "1970-01-01");
//         return dateB - dateA;
//     });
// };

// const ComplainFollowUpVersion2 = ({ connectionString }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const path = connectionString;
//     const userId = user?.UserId || null;
//     const role = user?.UserCategory || null;
//     const companyId = selectedCompany?.CompId || null;
//     const [dataSets, setDataSets] = useState({});
//     const [visibleCategory, setVisibleCategory] = useState(null);
//     const [recordCounts, setRecordCounts] = useState({ Missed: 0, Today: 0, Open: 0, Close: 0, Search: 0 });
//     const [searchQuery, setSearchQuery] = useState("");
//     const [openFollowUpPopup, setOpenFollowUpPopup] = useState(false);
//     const [selectedRecord, setSelectedRecord] = useState(null);
//     const navigate = useNavigate();

//     // Fetch complaint counts for each category
//     useEffect(() => {
//         const fetchCounts = async () => {
//             try {
//                 const countPromises = categories
//                     .filter(category => category !== "Search") // Exclude Search category
//                     .map(async (category) => {
//                         const params = { category, userId, role, companyId };
//                         const res = await axios.get(`${path}/api/get-complain`, {
//                             params,
//                             headers: { 'Cache-Control': 'no-store' }
//                         });
//                         return { category, totalRecords: res.data.totalRecords || 0 };
//                     });

//                 const results = await Promise.all(countPromises);
//                 const updatedCounts = results.reduce((acc, { category, totalRecords }) => ({
//                     ...acc,
//                     [category]: totalRecords
//                 }), { Search: 0 });

//                 console.log("Fetched counts:", updatedCounts);
//                 setRecordCounts(updatedCounts);
//             } catch (error) {
//                 console.error("Error fetching complaint counts:", error);
//                 setRecordCounts({ Missed: 0, Today: 0, Open: 0, Close: 0, Search: 0 });
//             }
//         };

//         if (userId && role && companyId) {
//             fetchCounts();
//         }
//     }, [userId, role, companyId]);

//     const fetchEnquiries = async (category, offset = 0) => {
//         if (category === "Search") return { complaints: [], totalRecords: 0 };
//         try {
//             const params = { category, offset, limit: 50, userId, role, companyId };
//             const res = await axios.get(`${path}/api/get-complain`, {
//                 params,
//                 headers: {
//                     'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
//                 }
//             });
//             console.log(`${category} complaints:`, res.data.complaints);
//             return { complaints: res.data.complaints || [], totalRecords: res.data.totalRecords || 0 };
//         } catch (error) {
//             console.error(`Error fetching ${category} enquiries:`, error);
//             return { complaints: [], totalRecords: 0 };
//         }
//     };

//     const fetchSearchResults = async (query) => {
//         try {
//             console.log("SEARCH TRIGGERED");
//             console.log("Raw query:", query);
//             console.log("userId:", userId);
//             console.log("role:", role);
//             console.log("companyId:", companyId);
//             console.log("connectionString:", connectionString);
//             const params = { query, userId, role, companyId };
//             const res = await axios.get(`${path}/client/search-clients`, { params });
//             console.log("Fetched search results:", res.data);
//             return { complaints: res.data.clients || [], totalRecords: res.data.totalRecords || 0 };
//         } catch (error) {
//             console.error("Error fetching search results:", error);
//             return { complaints: [], totalRecords: 0 };
//         }
//     };

//     const toggleCategory = async (category) => {
//         if (visibleCategory === category) {
//             setVisibleCategory(null);
//         } else {
//             setVisibleCategory(category);
//             if (category !== "Search") {
//                 const { complaints, totalRecords } = await fetchEnquiries(category, 0);
//                 const normalizedData = role === "Team Leader" ? sortRecordsForTeamLeader(complaints, userId) : complaints.sort((a, b) => new Date(b.AddUserDateTime || "1970-01-01") - new Date(a.AddUserDateTime || "1970-01-01"));
//                 setDataSets((prev) => ({ ...prev, [category]: normalizedData }));
//                 // setRecordCounts((prev) => ({ ...prev, [category]: totalRecords }));
//             }
//         }
//         setSearchQuery("");
//     };

//     const handleSearchChange = (e) => { setSearchQuery(e.target.value); };

//     const handleClearSearch = () => {
//         setSearchQuery("");
//         setDataSets((prev) => ({ ...prev, Search: [] }));
//         setRecordCounts((prev) => ({ ...prev, Search: 0 }));
//     };

//     const handleSearchSubmit = async (e) => {
//         if (e.key === "Enter" && searchQuery.trim()) {
//             const { complaints, totalRecords } = await fetchSearchResults(searchQuery.trim());
//             const normalizedData = role === "Team Leader" ? sortRecordsForTeamLeader(complaints, userId) : complaints.sort((a, b) => new Date(b.AddUserDateTime || "1970-01-01") - new Date(a.AddUserDateTime || "1970-01-01"));
//             setDataSets((prev) => ({ ...prev, Search: normalizedData }));
//             setRecordCounts((prev) => ({ ...prev, Search: totalRecords }));
//             setVisibleCategory("Search");
//         }
//     };

//     // const handleFirmNameClick = (record) => {
//     //     console.log("Clicked record:", record);
//     //     console.log("Current visibleCategory:", visibleCategory);

//     //     if (visibleCategory === "Search") {
//     //         setSelectedRecord({
//     //             mode: "insert",
//     //             ...record,
//     //             clientId: record.id,
//     //             clientName: record.FirmName,
//     //             contactPerson: record.ContactPerson,
//     //             mobileNo: record.MobileNo,
//     //             emailId: record.EmailId
//     //         });
//     //     } else {
//     //         setSelectedRecord(record);
//     //     }
//     //     setOpenFollowUpPopup(true);
//     // };

//     const handleFirmNameClick = (record) => {
//         if (visibleCategory === "Search") {
//             setSelectedRecord({
//                 mode: "insert",        // This tells ComplainForm it's insert
//                 clientId: record.id,
//                 FirmName: record.FirmName,
//                 ContactPerson: record.ContactPerson,
//                 MobileNo: record.MobileNo,
//                 EmailId: record.EmailId,
//                 City: record.City,
//                 state: record.state,
//                 Address: record.Address,
//                 // Pass everything needed
//                 ...record
//             });
//         } else {
//             setSelectedRecord(record); // normal followup record
//         }
//         setOpenFollowUpPopup(true);
//     };

//     const handleClosePopup = () => {
//         setOpenFollowUpPopup(false);
//         setSelectedRecord(null);
//     };

//     const columns = [
//         {
//             field: "index", headerName: "#", minWidth: 70, flex: 0.5, align: "center", sortable: false, filterable: false,
//             renderCell: (params) => {
//                 // const rowIndex = params.api.getRowIndex(params.id);
//                 const rowIndex = params.api.getRowIndexRelativeToVisibleRows(params.id);
//                 return <Typography sx={{ width: "100%", textAlign: "center" }}>{rowIndex + 1}</Typography>;
//             },
//         },
//         { field: "complainNumber", headerName: "Complain No", minWidth: 120, flex: 1, valueGetter: (params) => params.row.complainNumber || "N/A", },
//         { field: "complainDate", headerName: "Complain Date", minWidth: 120, flex: 1, renderCell: (params) => <FormattedDate dateString={params.value || params.row.AddUserDateTime} />, },
//         { field: "LastFollowUpDate", headerName: "Follow-Up Date", minWidth: 120, flex: 1, renderCell: (params) => <FormattedDate dateString={params.value || "N/A"} />, },
//         {
//             field: "statusName", headerName: "Status", minWidth: 100, flex: 0.8,
//             valueGetter: (params) => params.row.statusName || "N/A",
//             renderCell: (params) => {
//                 const statusText = params.value || params.row.statusName || "N/A";
//                 const color = getPriorityColor(statusText);
//                 return (
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                         <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: color }} />
//                         <Typography variant="body2" sx={{ textTransform: "capitalize" }}> {statusText} </Typography>
//                     </Box>
//                 );
//             },
//         },
//         {
//             field: "clientInfo", headerName: "Client Details", minWidth: 300, flex: 2, sortable: false, filterable: false,
//             renderCell: (params) => {
//                 const row = params.row || {};
//                 const name = row.clientname || row.FirmName || "N/A";
//                 const contact = row.clientContact || row.ContactPerson || "N/A";
//                 const mobile = row.MobileNo || row.mobileNo || row.contactNumber || "N/A";
//                 const email = row.EmailId || row.emailId || "N/A";
//                 return (
//                     <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//                         <Typography variant="subtitle2" onClick={() => handleFirmNameClick(row)} sx={{ fontWeight: "bold", textDecoration: "underline", color: "#1976d2", cursor: "pointer", "&:hover": { color: "#1565c0" }, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal", wordBreak: "break-word", }} >
//                             {name}
//                         </Typography>
//                         <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <PersonIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {contact} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <PhoneIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {mobile} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <EmailIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {email} </Typography>
//                             </Box>
//                         </Box>
//                     </Box>
//                 );
//             },
//         },
//         { field: "EmployeeName", headerName: "Assign", minWidth: 120, flex: 1, valueGetter: (params) => params.row.EmployeeName || params.row.employeeName || "N/A", },
//     ];

//     const getPriorityColor = (priority) => {
//         if (!priority) return "gray";
//         const p = String(priority).toLowerCase().trim();
//         if (p === "open") return "#388e3c"; // green
//         if (p === "close" || p === "closed") return "#d32f2f"; // red
//     };

//     const renderSearchComponent = () => (
//         <Box sx={{ py: 2, maxWidth: 800, mx: "auto", borderRadius: 3, p: 2 }}>
//             <TextField fullWidth label="Search Clients" value={searchQuery} onChange={handleSearchChange} onKeyDown={handleSearchSubmit}
//                 InputProps={{
//                     endAdornment: searchQuery ? (
//                         <InputAdornment position="end">
//                             <IconButton onClick={handleClearSearch}>
//                                 <HiOutlineXCircle />
//                             </IconButton>
//                         </InputAdornment>
//                     ) : null,
//                 }}
//                 sx={{
//                     backgroundColor: "white",
//                     "& .MuiOutlinedInput-root": { borderRadius: "100px" },
//                 }}
//             />
//             {dataSets.Search?.length > 0 && (
//                 <Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 2.5 }}>
//                     {dataSets.Search.map((record) => {
//                         return (
//                             <Card key={record.id} sx={{ boxShadow: 4, borderRadius: 3, transition: "all 0.2s ease-in-out", bgcolor: "white" }}>
//                                 <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1.5, p: 3 }}>
//                                     <Typography variant="h5" onClick={() => handleFirmNameClick(record)} sx={{ fontWeight: "bold", textDecoration: "underline", color: "#1976d2", cursor: "pointer", "&:hover": { color: "#1565c0" }, }} >
//                                         {record.FirmName || "N/A"}
//                                     </Typography>
//                                     <Divider sx={{ my: 1 }} />
//                                     <Box sx={{ display: "flex", gap: 4, mt: 2 }}>
//                                         <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1.5 }}>
//                                             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                                 <PersonIcon sx={{ color: "grey.600", fontSize: 20 }} />
//                                                 <Typography variant="body2" sx={{ color: "grey.700" }}>
//                                                     <strong>Contact:</strong>{" "}
//                                                     <span style={{ color: "grey.900" }}>{record.ContactPerson || "N/A"}</span>
//                                                 </Typography>
//                                             </Box>
//                                             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                                 <PhoneIcon sx={{ color: "grey.600", fontSize: 20 }} />
//                                                 <Typography variant="body2" sx={{ color: "grey.700" }}>
//                                                     <strong>Mobile:</strong>{" "}
//                                                     <span style={{ color: "grey.900" }}>{record.MobileNo || "N/A"}</span>
//                                                 </Typography>
//                                             </Box>
//                                             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                                 <EmailIcon sx={{ color: "grey.600", fontSize: 20 }} />
//                                                 <Typography variant="body2" sx={{ color: "grey.700" }}>
//                                                     <strong>Email:</strong>{" "}
//                                                     <span style={{ color: "grey.900" }}>{record.EmailId || "N/A"}</span>
//                                                 </Typography>
//                                             </Box>
//                                         </Box>
//                                         <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1.5 }}>
//                                             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                                 <LocationCityIcon sx={{ color: "grey.600", fontSize: 20 }} />
//                                                 <Typography variant="body2" sx={{ color: "grey.700" }}>
//                                                     <strong>City:</strong>{" "}
//                                                     <span style={{ color: "grey.900" }}>{record.City || "N/A"}</span>
//                                                 </Typography>
//                                             </Box>
//                                             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                                 <LocationCityIcon sx={{ color: "grey.600", fontSize: 20 }} />
//                                                 <Typography variant="body2" sx={{ color: "grey.700" }}>
//                                                     <strong>State:</strong>{" "}
//                                                     <span style={{ color: "grey.900" }}>{record.state || "N/A"}</span>
//                                                 </Typography>
//                                             </Box>
//                                         </Box>
//                                     </Box>
//                                 </CardContent>
//                             </Card>
//                         );
//                     })}
//                     <Typography variant="subtitle1" sx={{ mt: 3, color: "grey.800", fontWeight: "medium" }}>
//                         Showing {dataSets.Search.length} of {recordCounts.Search || 0} results
//                     </Typography>
//                 </Box>
//             )}
//             {dataSets.Search?.length === 0 && searchQuery && (
//                 <Box textAlign={"center"}>
//                     <Typography variant="subtitle1" sx={{ mt: 3, color: "grey.600", textAlign: "center" }}>
//                         No results found for "{searchQuery}"
//                     </Typography>
//                     <Button variant="contained" color="primary" size="small" sx={{mt:3}}> Add New Client</Button>
//                 </Box>
//             )}
//         </Box>
//     );

//     const renderDataGrid = (category) => {
//         const data = dataSets[category] || [];
//         const rows = data.map((record) => ({ ...record }));
//         return (
//             <Box sx={{ width: "100%", maxWidth: "100%", overflowX: "auto", p: 2 }}>
//                 <DataGrid rows={rows} columns={columns} pageSizeOptions={[10, 25, 50]} autoHeight disableSelectionOnClick getRowId={(row) => row.complainId} getRowHeight={() => "auto"}
//                     sx={{
//                         "& .MuiDataGrid-cell": { cursor: "pointer", whiteSpace: "normal", lineHeight: 1.4, py: 1, alignItems: "flex-start", display: "flex" },
//                         "& .MuiDataGrid-columnHeader": { backgroundColor: themeColors.primary.surface, color: themeColors.neutral.sub, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },
//                         width: "100%",
//                     }}
//                 />
//                 <Typography variant="subtitle1" sx={{ mt: 2 }}>
//                     Count: {rows.length} / {recordCounts[category] || 0}
//                 </Typography>
//             </Box>
//         );
//     };

//     return (
//         <Container sx={{ py: 1 }}>
//             <Typography variant="h4" align="center" gutterBottom sx={{ textDecoration: "underline" }}>
//                 Complaint Follow-Up
//             </Typography>
//             <Box sx={{ display: "grid", gap: { xs: 1.5, sm: 3, md: 3 }, my: 1, gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(5, 1fr)" } }}>
//                 {categories.map((type, index) => {
//                     const colors = ["#60A5FA", "#F472B6", "#4ADE80", "#FACC15", "#F87171"];
//                     const icons = {
//                         Search: <MdSearch style={{ width: 28, height: 28, color: "white" }} />,
//                         Missed: <HiOutlineClock style={{ width: 28, height: 28, color: "white" }} />,
//                         Today: <HiOutlineCalendar style={{ width: 28, height: 28, color: "white" }} />,
//                         Open: <FaLockOpen style={{ width: 28, height: 28, color: "white" }} />,
//                         Close: <FaLock style={{ width: 28, height: 28, color: "white" }} />,
//                     };
//                     return (
//                         <Box key={type} onClick={() => toggleCategory(type)}
//                             sx={{ cursor: "pointer", color: "white", fontWeight: "bold", boxShadow: { xs: 3, sm: 2 }, borderRadius: 3, display: "flex", flexDirection: { xs: "row", sm: "column" }, alignItems: "center", justifyContent: { xs: "space-between", sm: "center" }, textAlign: { xs: "left", sm: "center" }, width: "100%", height: { xs: 55, sm: 110, md: 130, lg: 130 }, transition: "all 0.25s ease-in-out", "&:hover": { transform: "scale(1.03)", boxShadow: 6 }, backgroundColor: colors[index % colors.length], p: { xs: 1, sm: 2.5, md: 3 }, }}
//                         >
//                             {icons[type]}
//                             <Typography variant="subtitle2" sx={{ mt: 0, fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem", lg: "1.2rem" } }}>
//                                 {type.toUpperCase()}
//                             </Typography>
//                             {type !== "Search" && (
//                                 <Typography variant="body2" sx={{ mt: 0, fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" } }}>
//                                     {recordCounts[type] || 0}
//                                 </Typography>
//                             )}
//                         </Box>
//                     );
//                 })}
//             </Box>
//             {visibleCategory === "Search" && renderSearchComponent()}
//             {visibleCategory && visibleCategory !== "Search" && renderDataGrid(visibleCategory)}
//             <Dialog open={openFollowUpPopup} onClose={handleClosePopup} maxWidth="lg" fullWidth>
//                 <DialogContent sx={{ p: 0, position: 'relative' }}>
//                     <CloseIcon onClick={handleClosePopup} sx={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer', color: 'grey.700', zIndex: 10 }} />

//                     {selectedRecord && (
//                         <ComplainForm onClose={selectedRecord.mode === "insert" ? null : handleClosePopup} mode={selectedRecord.mode || "followup"} ComplainData={{ complain: selectedRecord }} connectionString={connectionString} />
//                     )}
//                 </DialogContent>
//             </Dialog>
//         </Container>
//     );
// };

// export default ComplainFollowUpVersion2;



import { colors as themeColors } from '../utils/theme';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Container, Box, Grid, Typography, IconButton, TextField, InputAdornment, Card, CardContent, Divider, Dialog, DialogContent, Button, Chip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { HiOutlineXCircle, HiOutlineClock, HiOutlineCalendar } from "react-icons/hi";
import { MdSearch } from "react-icons/md";
import { FaLockOpen, FaLock } from "react-icons/fa";
import { Person as PersonIcon, Phone as PhoneIcon, Email as EmailIcon, LocationCity as LocationCityIcon } from "@mui/icons-material";
import FormattedDate from "../components/FormattedDate";
import ComplainForm from "./ComplainForm"; // Import ComplainForm
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '../context/AuthContext';
import { FaCheck } from "react-icons/fa6";

const categories = ["Search", "Missed", "Today", "Open", "Close"];

const sortRecordsForTeamLeader = (records, userId) => {
    const recs = Array.isArray(records) ? records : [];
    return recs.sort((a, b) => {
        const aIsSelf = a.AddUserId === userId;
        const bIsSelf = b.AddUserId === userId;
        if (aIsSelf && !bIsSelf) return -1;
        if (!aIsSelf && bIsSelf) return 1;
        const dateA = new Date(a.AddUserDateTime || "1970-01-01");
        const dateB = new Date(b.AddUserDateTime || "1970-01-01");
        return dateB - dateA;
    });
};

const ComplainFollowUpVersion2 = ({ connectionString }) => {
    const { user, selectedCompany, loading } = useAuth();
    const path = connectionString;
    const userId = user?.UserId || null;
    const role = user?.UserCategory || null;
    const companyId = selectedCompany?.CompId || null;
    const [dataSets, setDataSets] = useState({});
    const [visibleCategory, setVisibleCategory] = useState(null);
    const [recordCounts, setRecordCounts] = useState({ Missed: 0, Today: 0, Open: 0, Close: 0, Search: 0 });
    const [searchQuery, setSearchQuery] = useState("");
    const [openFollowUpPopup, setOpenFollowUpPopup] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const navigate = useNavigate();

    // Fetch complaint counts for each category
    useEffect(() => {
        const fetchCounts = async () => {
            try {
                const countPromises = categories
                    .filter(category => category !== "Search") // Exclude Search category
                    .map(async (category) => {
                        const params = { category, userId, role, companyId };
                        const res = await axios.get(`${path}/api/get-complain`, {
                            params,
                            headers: { 'Cache-Control': 'no-store' }
                        });
                        return { category, totalRecords: res.data.totalRecords || 0 };
                    });

                const results = await Promise.all(countPromises);
                const updatedCounts = results.reduce((acc, { category, totalRecords }) => ({
                    ...acc,
                    [category]: totalRecords
                }), { Search: 0 });

                console.log("Fetched counts:", updatedCounts);
                setRecordCounts(updatedCounts);
            } catch (error) {
                console.error("Error fetching complaint counts:", error);
                setRecordCounts({ Missed: 0, Today: 0, Open: 0, Close: 0, Search: 0 });
            }
        };

        if (userId && role && companyId) {
            fetchCounts();
        }
    }, [userId, role, companyId]);

    const fetchEnquiries = async (category, offset = 0) => {
        if (category === "Search") return { complaints: [], totalRecords: 0 };
        try {
            const params = { category, offset, limit: 50, userId, role, companyId };
            const res = await axios.get(`${path}/api/get-complain`, {
                params,
                headers: {
                    'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
                }
            });
            console.log(`${category} complaints:`, res.data.complaints);
            return { complaints: res.data.complaints || [], totalRecords: res.data.totalRecords || 0 };
        } catch (error) {
            console.error(`Error fetching ${category} enquiries:`, error);
            return { complaints: [], totalRecords: 0 };
        }
    };

    const fetchSearchResults = async (query) => {
        try {
            console.log("SEARCH TRIGGERED");
            console.log("Raw query:", query);
            console.log("userId:", userId);
            console.log("role:", role);
            console.log("companyId:", companyId);
            console.log("connectionString:", connectionString);
            const params = { query, userId, role, companyId };
            const res = await axios.get(`${path}/client/search-clients`, { params });
            console.log("Fetched search results:", res.data);
            return { complaints: res.data.clients || [], totalRecords: res.data.totalRecords || 0 };
        } catch (error) {
            console.error("Error fetching search results:", error);
            return { complaints: [], totalRecords: 0 };
        }
    };

    const toggleCategory = async (category) => {
        if (visibleCategory === category) {
            setVisibleCategory(null);
        } else {
            setVisibleCategory(category);
            if (category !== "Search") {
                const { complaints, totalRecords } = await fetchEnquiries(category, 0);
                const normalizedData = role === "Team Leader" ? sortRecordsForTeamLeader(complaints, userId) : complaints.sort((a, b) => new Date(b.AddUserDateTime || "1970-01-01") - new Date(a.AddUserDateTime || "1970-01-01"));
                setDataSets((prev) => ({ ...prev, [category]: normalizedData }));
                // setRecordCounts((prev) => ({ ...prev, [category]: totalRecords }));
            }
        }
        setSearchQuery("");
    };

    const handleSearchChange = (e) => { setSearchQuery(e.target.value); };

    const handleClearSearch = () => {
        setSearchQuery("");
        setDataSets((prev) => ({ ...prev, Search: [] }));
        setRecordCounts((prev) => ({ ...prev, Search: 0 }));
    };

    const handleSearchSubmit = async (e) => {
        if (e.key === "Enter" && searchQuery.trim()) {
            const { complaints, totalRecords } = await fetchSearchResults(searchQuery.trim());
            const normalizedData = role === "Team Leader" ? sortRecordsForTeamLeader(complaints, userId) : complaints.sort((a, b) => new Date(b.AddUserDateTime || "1970-01-01") - new Date(a.AddUserDateTime || "1970-01-01"));
            setDataSets((prev) => ({ ...prev, Search: normalizedData }));
            setRecordCounts((prev) => ({ ...prev, Search: totalRecords }));
            setVisibleCategory("Search");
        }
    };

    // const handleFirmNameClick = (record) => {
    //     console.log("Clicked record:", record);
    //     console.log("Current visibleCategory:", visibleCategory);

    //     if (visibleCategory === "Search") {
    //         setSelectedRecord({
    //             mode: "insert",
    //             ...record,
    //             clientId: record.id,
    //             clientName: record.FirmName,
    //             contactPerson: record.ContactPerson,
    //             mobileNo: record.MobileNo,
    //             emailId: record.EmailId
    //         });
    //     } else {
    //         setSelectedRecord(record);
    //     }
    //     setOpenFollowUpPopup(true);
    // };

    const handleFirmNameClick = (record) => {
        if (visibleCategory === "Search") {
            setSelectedRecord({
                mode: "insert",        // This tells ComplainForm it's insert
                clientId: record.id,
                FirmName: record.FirmName,
                ContactPerson: record.ContactPerson,
                MobileNo: record.MobileNo,
                EmailId: record.EmailId,
                City: record.City,
                state: record.state,
                Address: record.Address,
                // Pass everything needed
                ...record
            });
        } else {
            setSelectedRecord(record); // normal followup record
        }
        setOpenFollowUpPopup(true);
    };

    const handleClosePopup = () => {
        setOpenFollowUpPopup(false);
        setSelectedRecord(null);
    };

    const columns = [
        {
            field: "index", headerName: "#", minWidth: 70, flex: 0.5, align: "center", sortable: false, filterable: false,
            renderCell: (params) => {
                // const rowIndex = params.api.getRowIndex(params.id);
                const rowIndex = params.api.getRowIndexRelativeToVisibleRows(params.id);
                return <Typography sx={{ width: "100%", textAlign: "center" }}>{rowIndex + 1}</Typography>;
            },
        },
        { field: "complainNumber", headerName: "Complain No", minWidth: 120, flex: 1,valueGetter: (value, row) => row?.complainNumber || "N/A"},
        { field: "complainDate", headerName: "Complain Date", minWidth: 120, flex: 1, renderCell: (params) => <FormattedDate dateString={params.value || params.row.AddUserDateTime} />, },
        { field: "LastFollowUpDate", headerName: "Follow-Up Date", minWidth: 120, flex: 1, renderCell: (params) => <FormattedDate dateString={params.value || "N/A"} />, },
        {
            field: "statusName", headerName: "Status", minWidth: 100, flex: 0.8,
            valueGetter: (value, row) => row?.statusName || "N/A",
            renderCell: (params) => {
                const statusText = params.value || params.row.statusName || "N/A";
                const color = getPriorityColor(statusText);
                return (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: color }} />
                        <Typography variant="body2" sx={{ textTransform: "capitalize" }}> {statusText} </Typography>
                    </Box>
                );
            },
        },
        {
            field: "clientInfo", headerName: "Client Details", minWidth: 300, flex: 2, sortable: false, filterable: false,
            renderCell: (params) => {
                const row = params.row || {};
                const name = row.clientname || row.FirmName || "N/A";
                const contact = row.clientContact || row.ContactPerson || "N/A";
                const mobile = row.MobileNo || row.mobileNo || row.contactNumber || "N/A";
                const email = row.EmailId || row.emailId || "N/A";
                return (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                        <Typography variant="subtitle2" onClick={() => handleFirmNameClick(row)} sx={{ fontWeight: "bold", textDecoration: "underline", color: themeColors.primary.main, cursor: "pointer", "&:hover": { color: themeColors.primary.dark }, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal", wordBreak: "break-word", }} >
                            {name}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                                <PersonIcon sx={{ fontSize: 16, color: "grey.600" }} />
                                <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {contact} </Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                                <PhoneIcon sx={{ fontSize: 16, color: "grey.600" }} />
                                <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {mobile} </Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                                <EmailIcon sx={{ fontSize: 16, color: "grey.600" }} />
                                <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {email} </Typography>
                            </Box>
                        </Box>
                    </Box>
                );
            },
        },
        { field: "EmployeeName", headerName: "Assign", minWidth: 120, flex: 1,valueGetter: (value, row) => row.EmployeeName || row.employeeName || "N/A"},
    ];

    const getPriorityColor = (priority) => {
        if (!priority) return "gray";
        const p = String(priority).toLowerCase().trim();
        if (p === "open") return "#388e3c"; // green
        if (p === "close" || p === "closed") return themeColors.error.dark; // red
    };

    const renderSearchComponent = () => (
        <Box sx={{ py: 2, maxWidth: 800, mx: "auto", borderRadius: 3, p: 2 }}>
            <TextField fullWidth label="Search Clients" value={searchQuery} onChange={handleSearchChange} onKeyDown={handleSearchSubmit}
                InputProps={{
                    endAdornment: searchQuery ? (
                        <InputAdornment position="end">
                            <IconButton onClick={handleClearSearch}>
                                <HiOutlineXCircle />
                            </IconButton>
                        </InputAdornment>
                    ) : null,
                }}
                sx={{
                    backgroundColor: "white",
                    "& .MuiOutlinedInput-root": { borderRadius: "100px" },
                }}
            />
            {dataSets.Search?.length > 0 && (
                <Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 2.5 }}>
                    {dataSets.Search.map((record) => {
                        return (
                            <Card key={record.id} sx={{ boxShadow: 4, borderRadius: 3, transition: "all 0.2s ease-in-out", bgcolor: "white" }}>
                                <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1.5, p: 3 }}>
                                    <Typography variant="h5" onClick={() => handleFirmNameClick(record)} sx={{ fontWeight: "bold", textDecoration: "underline", color: themeColors.primary.main, cursor: "pointer", "&:hover": { color: themeColors.primary.dark }, }} >
                                        {record.FirmName || "N/A"}
                                    </Typography>
                                    <Divider sx={{ my: 1 }} />
                                    <Box sx={{ display: "flex", gap: 4, mt: 2 }}>
                                        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1.5 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <PersonIcon sx={{ color: "grey.600", fontSize: 20 }} />
                                                <Typography variant="body2" sx={{ color: "grey.700" }}>
                                                    <strong>Contact:</strong>{" "}
                                                    <span style={{ color: "grey.900" }}>{record.ContactPerson || "N/A"}</span>
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <PhoneIcon sx={{ color: "grey.600", fontSize: 20 }} />
                                                <Typography variant="body2" sx={{ color: "grey.700" }}>
                                                    <strong>Mobile:</strong>{" "}
                                                    <span style={{ color: "grey.900" }}>{record.MobileNo || "N/A"}</span>
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <EmailIcon sx={{ color: "grey.600", fontSize: 20 }} />
                                                <Typography variant="body2" sx={{ color: "grey.700" }}>
                                                    <strong>Email:</strong>{" "}
                                                    <span style={{ color: "grey.900" }}>{record.EmailId || "N/A"}</span>
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1.5 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <LocationCityIcon sx={{ color: "grey.600", fontSize: 20 }} />
                                                <Typography variant="body2" sx={{ color: "grey.700" }}>
                                                    <strong>City:</strong>{" "}
                                                    <span style={{ color: "grey.900" }}>{record.City || "N/A"}</span>
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <LocationCityIcon sx={{ color: "grey.600", fontSize: 20 }} />
                                                <Typography variant="body2" sx={{ color: "grey.700" }}>
                                                    <strong>State:</strong>{" "}
                                                    <span style={{ color: "grey.900" }}>{record.state || "N/A"}</span>
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        );
                    })}
                    <Typography variant="subtitle1" sx={{ mt: 3, color: "grey.800", fontWeight: "medium" }}>
                        Showing {dataSets.Search.length} of {recordCounts.Search || 0} results
                    </Typography>
                </Box>
            )}
            {dataSets.Search?.length === 0 && searchQuery && (
                <Box textAlign={"center"}>
                    <Typography variant="subtitle1" sx={{ mt: 3, color: "grey.600", textAlign: "center" }}>
                        No results found for "{searchQuery}"
                    </Typography>
                    <Button variant="contained" color="primary" size="small" sx={{mt:3}}> Add New Client</Button>
                </Box>
            )}
        </Box>
    );

    const renderDataGrid = (category) => {
        const data = dataSets[category] || [];
        const rows = data.map((record) => ({ ...record }));
        return (
            <Box sx={{ width: "100%", maxWidth: "100%", overflowX: "auto", p: 2 }}>
                <DataGrid rows={rows} columns={columns} pageSizeOptions={[10, 25, 50]} autoHeight disableSelectionOnClick getRowId={(row) => row.complainId} getRowHeight={() => "auto"}
                    sx={{
                        "& .MuiDataGrid-cell": { cursor: "pointer", whiteSpace: "normal", lineHeight: 1.4, py: 1, alignItems: "flex-start", display: "flex" },
                        "& .MuiDataGrid-columnHeader": { backgroundColor: themeColors.primary.surface, color: themeColors.neutral.sub, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },
                        width: "100%",
                    }}
                />
                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    Count: {rows.length} / {recordCounts[category] || 0}
                </Typography>
            </Box>
        );
    };

    return (
        <Container sx={{ py: 1 }}>
            <Typography variant="h4" align="center" gutterBottom >
                Complaint Follow-Up
            </Typography>
           <Box
  sx={{
    display: "flex",
    flexWrap: "wrap",
    gap: 1.2,
    justifyContent: "center",
    my: 1,
  }}
>
  {categories.map((type, index) => {
    const colors = ["#60A5FA", "#F472B6", "#4ADE80", "#FACC15", "#F87171"];

    const icons = {
      Search: <MdSearch size={18} />,
      Missed: <HiOutlineClock size={18} />,
      Today: <HiOutlineCalendar size={18} />,
      Open: <FaLockOpen size={18} />,
      Close: <FaLock size={18} />,
    };

    const isSelected = visibleCategory === type;
    const count = recordCounts[type] || 0;

    return (
      <Chip
        key={type}
        clickable
        onClick={() => toggleCategory(type)}
        sx={{
          height: 45,
          px: 1.8,
          borderRadius: 3,
          bgcolor: colors[index % colors.length],
          color: themeColors.neutral.surface,

          border: isSelected
            ? `1px solid ${themeColors.neutral.surface}`
            : `1px solid ${colors[index % colors.length]}`,

          outline: isSelected
            ? `2px solid ${colors[index % colors.length]}`
            : "none",

          transform: isSelected ? "scale(1.05)" : "scale(1)",
          boxShadow: isSelected
            ? "0 4px 12px rgba(0,0,0,0.2)"
            : "none",

          transition: "all 0.25s ease",

          "&:hover": {
            bgcolor: colors[index % colors.length],
            transform: isSelected ? "scale(1.05)" : "translateY(-2px)",
          },
        }}
        label={
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              py: 0.6,
            }}
          >
            {/* ICON + NAME */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
              {icons[type]}

              <Typography sx={{ fontSize: 15, color: themeColors.neutral.surface }}>
                {type.toUpperCase()}
              </Typography>

              {isSelected && (
                <Box
                  sx={{
                    ml: 0.5,
                    bgcolor: "#f2f2f2",
                    p: 0.2,
                    color: "green",
                    borderRadius: "50%",
                    fontSize: "12px",
                  }}
                >
                  <FaCheck />
                </Box>
              )}
            </Box>

            {/* COUNT */}
            {type !== "Search" && (
              <Typography
                sx={{
                  fontSize: 17,
                  fontWeight: 500,
                  color: themeColors.neutral.surface,
                  lineHeight: 1,
                }}
              >
                {count}
              </Typography>
            )}
          </Box>
        }
      />
    );
  })}
</Box>
            {visibleCategory === "Search" && renderSearchComponent()}
            {visibleCategory && visibleCategory !== "Search" && renderDataGrid(visibleCategory)}
            <Dialog open={openFollowUpPopup} onClose={handleClosePopup} maxWidth="lg" fullWidth>
                <DialogContent sx={{ p: 0, position: 'relative' }}>
                    <CloseIcon onClick={handleClosePopup} sx={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer', color: 'grey.700', zIndex: 10 }} />

                    {selectedRecord && (
                        <ComplainForm onClose={selectedRecord.mode === "insert" ? null : handleClosePopup} mode={selectedRecord.mode || "followup"} ComplainData={{ complain: selectedRecord }} connectionString={connectionString} />
                    )}
                </DialogContent>
            </Dialog>
        </Container>
    );
};

export default ComplainFollowUpVersion2;